import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { useAuth } from "../pages/login/AuthProvider";
import "../styles/navbar.scss";

export default function MNavbar() {
    const { authorized, chinese_name, account, logout } = useAuth();
    const displayName =
  (!chinese_name || chinese_name === account)
    ? (account?.split("@")[0] ?? "")
    : chinese_name;
    return (
        <>
            <Navbar expand="xl" variant="dark" style={{ backgroundColor: '#152046' }}>
                <div className="container d-flex justify-content-between">
                    {/* Logo */}
                    <NavLink className="navbar-brand logo" to="/">
                        <img src="/logo/logo.svg" alt="Logo" />
                    </NavLink>

                    {/* 中間選單 */}
                    <Navbar.Toggle aria-controls="mnavbarScroll" />
                    <Navbar.Collapse id="mnavbarScroll">
                        <Nav className="d-flex justify-content-start">
                            <Nav.Item className="flex-fill">
                                <NavLink className="nav-link" to="./about/origin">
                                    關於捷進
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <NavLink className="nav-link" to="./becker">
                                    美國 Becker
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <NavLink className="nav-link" to="./cpa">
                                    國際證照考試
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <NavLink className="nav-link" to="./service">
                                    服務項目
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <Link className="nav-link" to="./share">
                                    成功案例
                                </Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <Link className="nav-link" to="./video">
                                    影音專區
                                </Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill">
                                <Link className="nav-link" to="./faq">
                                    FAQ
                                </Link>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>

                    {/* 右側會員與功能圖示 */}
                    <div className="d-flex align-items-center ms-auto">
                        <Link to="/consult" className="me-3 text-white">
                            <i className="fa-solid fa-comment"></i>
                        </Link>
                        <Link to="/audition" className="me-3 text-white">
                            <i className="fa-solid fa-headphones"></i>
                        </Link>
                        {authorized ? (
                            <div className="d-flex align-items-center text-white">
                                <NavLink to="/member" className="text-white me-3">
                                    <i className="fa-solid fa-user" />
                                </NavLink>
                                <div className="memname me-3">{displayName}</div>
                                <div
                                    className="text-white logouttext"
                                    onClick={() => logout()}
                                    style={{ cursor: "pointer" }}
                                >
                                    登出
                                </div>
                            </div>
                        ) : (
                            <Link to="/member/memberlogin" className="text-white">
                                <i className="fa-solid fa-user" />
                            </Link>
                        )}
                    </div>
                </div>
            </Navbar>
        </>
    );
}